
export function discountPriceByPercent(price: number, discount: number): number {
  return price - (price * (discount / 100.0));
}
